export default __webpack_public_path__ + "static/5-564fd0bf559807655a2d553cc059f71b.png";